<template>
  <div class="popup popup--md active">
    <div class="popup__wrap">
      <div class="popup__box">
        <div class="popup__head">
          <div class="popup__title">
            <p>{{selectedMemberName}} 평가권한 배분</p>
          </div>
          <button type="button" class="popup__close icon-only icon-x" @click="popupClose"></button>
        </div>
        <div class="popup__body">

          <div class="standards-tree">
            <!-- 도메인 렌더링 -->
            <div v-for="domain in transformedDomains" :key="domain.domainCode" class="domain" :class="{ 'selected': isDomainFullySelected(domain) }">
              <div class="domain-title">
                <!-- 도메인 제목 클릭 시 전체 선택/해제 -->
                <span @click="toggleDomainSelection(domain)" class="domain-title-text">
                  {{ domain.domainCode }}. {{ domain.domainName }}
                </span>
                
                <!-- 펼침/닫힘 버튼 -->
                <span @click.stop="toggleDomainExpand(domain.domainCode)" class="domain-toggle">
                  {{ expandedDomains.includes(domain.domainCode) ? '▲' : '▼' }}
                </span>
              </div>

              <!-- 스탠다드 목록 -->
              <ul 
                v-show="expandedDomains.includes(domain.domainCode)"
                class="standard-list"
              >
                <li
                  v-for="standard in domain.standards"
                  :key="standard.standardCode"
                  class="standard-item"
                  :class="{ selected: selectedStandards.includes(standard.standardCode) }"
                  @click="toggleSelection(standard.standardCode)"
                >
                  {{ standard.standardCode }} - {{ standard.standardName }}
                </li>
              </ul>
            </div>
          </div>



        </div>
        <div class="popup__btns">
          <button type="button" class="btn btn--sm btn--basic icon-check" @click="popupClose">닫기</button>
          <!-- <button
            type="button"
            class="btn btn--sm btn--primary icon-check"
            @click="registerStandards"
            :disabled="selectedStandards.length === 0"
          >
            등록
          </button> -->
        </div>
      </div>
      <div class="popup__bg"></div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import { ApprovedStandardList,
ApprovedStandardUpdate,
checkUpdateApprovedStandardBeFor,
updateApprovedStandardBeFor } from '@/api/user'

const store = useStore();
// 선택된 항목의 standardCode 배열
const selectedStandards = ref([]);

// 확장된 도메인 (도메인 클릭 시 열림/닫힘)
const expandedDomains = ref([]);

// 스토어에서 데이터 매핑
const standardsList = computed(() => store.state.grid.standardData || []);

//부모한테서 데이터 가져옴
const selectedMember = computed(() => store.state.member.member)

const selectedOrgCode = computed(() => store.state.member.orgCode  || [] )

const selectedMemberName = computed(() => store.state.member.memberName)

const transformedDomains = computed(() => transformToTreeStructure(standardsList.value));

// 도메인 펼침/닫힘 토글
const toggleDomainExpand = (domainCode) => {
  if (expandedDomains.value.includes(domainCode)) {
    expandedDomains.value = expandedDomains.value.filter((code) => code !== domainCode);
  } else {
    expandedDomains.value.push(domainCode);
  }
};
// 모든 스탠다드가 선택되었는지 확인
const isDomainFullySelected = (domain) => {
  const allStandards = domain.standards.map((standard) => standard.standardCode);
  return allStandards.every((code) => selectedStandards.value.includes(code));
};


/**
 * 도메인 클릭 시
 * - 도메인 열기/닫기
 * - 모든 스탠다드 선택/해제
 */
 const toggleDomain = (domain) => {
  // 도메인 열기/닫기 토글
  if (expandedDomains.value.includes(domain.domainCode)) {
    expandedDomains.value = expandedDomains.value.filter((code) => code !== domain.domainCode);
  } else {
    expandedDomains.value.push(domain.domainCode);
  }

  // 도메인 내 모든 스탠다드 선택/해제
  const allStandards = domain.standards.map((standard) => standard.standardCode);
  const isAllSelected = allStandards.every((code) => selectedStandards.value.includes(code));

  if (isAllSelected) {
    // 전체 선택된 경우, 모두 해제
    selectedStandards.value = selectedStandards.value.filter((code) => !allStandards.includes(code));
  } else {
    // 일부 또는 모두 선택되지 않은 경우, 모두 선택
    allStandards.forEach((code) => {
      if (!selectedStandards.value.includes(code)) {
        selectedStandards.value.push(code);
      }
    });
  }
};

// 스탠다드 선택/해제
const toggleSelection = (standardCode) => {
  if (selectedStandards.value.includes(standardCode)) {
    selectedStandards.value = selectedStandards.value.filter((code) => code !== standardCode);
  } else {
    selectedStandards.value.push(standardCode);
  }
};


// 도메인 선택/해제
const toggleDomainSelection = (domain) => {
  const allStandards = domain.standards.map((standard) => standard.standardCode);
  const isAllSelected = allStandards.every((code) => selectedStandards.value.includes(code));

  if (isAllSelected) {
    // 전체 선택된 경우 → 해제
    selectedStandards.value = selectedStandards.value.filter((code) => !allStandards.includes(code));
  } else {
    // 일부 또는 전체 선택되지 않은 경우 → 전체 선택
    allStandards.forEach((code) => {
      if (!selectedStandards.value.includes(code)) {
        selectedStandards.value.push(code);
      }
    });
  }
};


const transformToTreeStructure = (data) => {
  const groupedData = {};

  data.forEach((item) => {
    // 도메인 코드와 이름이 없으면 무시
    if (!item.domainCode || !item.domainName) {
      console.warn(`⚠️ 유효하지 않은 데이터 발견:`, item);
      return;
    }

    // 도메인 그룹화
    if (!groupedData[item.domainCode]) {
      groupedData[item.domainCode] = {
        domainCode: item.domainCode,
        domainName: item.domainName,
        standards: [],
      };
    }

    // 스탠다드 추가
    groupedData[item.domainCode].standards.push({
      standardCode: item.standardCode || 'N/A',
      standardName: item.standardName || 'Unnamed Standard',
    });
  });

  // 객체를 배열로 변환
  return Object.values(groupedData);
};

// 등록 버튼 클릭 시 호출
const registerStandards = async() => {
  	console.log("선택된 항목들:", selectedStandards.value); // 선택된 코드 배열 콘솔에 출력
	const sortedStandards = [...selectedStandards.value].sort((a, b) => {
        // 문자열로 정렬하되 숫자 순서에 맞게 비교
        if (a < b) return -1;
        if (a > b) return 1;
        return 0;
    });

	let param = {
		memberCode : selectedMember.value,
		approvedStandardList : sortedStandards
	}
  let rtn = await checkUpdateApprovedStandardBeFor(param);

  if(rtn.result == "ok"){ // 이미 저장할 데이터가 있음
    if(confirm(rtn.resultMsg)){ // 예 누름
      let rtn2 = await updateApprovedStandardBeFor(param); // 삭제할 데이터 삭제함
      if(rtn2.result == "ok"){
        let rtn3 = await ApprovedStandardUpdate(param); // 삭제한 다음에 업데이트함
        if(rtn3.result == "ok"){
          alert(rtn3.resultMsg)
          popupClose()
        }else{
          alert(rtn3.resultMsg)
        }
      }else{ // 삭제할 데이터가 없으면
        alert("삭제할 데이터 없음")
      }
    }else{
      alert("작업을 취소 하셨습니다.")
    }
  }else{
    let rtn3 = await ApprovedStandardUpdate(param);
      if(rtn3.result == "ok"){
        alert(rtn3.resultMsg)
        popupClose()
      }else{
        alert(rtn3.resultMsg)
      }
  }
};

// 데이터 초기화 (API 호출로 대체 가능)
const getGridData = async () => {
  await store.dispatch("grid/fetchStandard");
};

onMounted(async () => {
  console.log("부모창에서 받은 팝업 데이터: ", selectedMember.value);
  console.log("부모창에서 받은 팝업 데이터2: ", selectedOrgCode.value);
  console.log("부모창에서 받은 유저이름: ", selectedMemberName.value);
  await getGridData();

  // ✅ selectedMember.value가 문자열이 아닌 객체인지 검사
  if (typeof selectedMember.value === "object") {
    store.commit("temp/setIsApprovedStandard");
    return; // 🚨 이후 코드 실행을 막음
  }

  if (selectedMember.value) { 
    const params = { memberCode: String(selectedMember.value) }; // 객체로 전달
    let rtn = await ApprovedStandardList(params);

    if (rtn.result === "ok") {
      console.log("API 반환 데이터:", rtn.data);
    } else { 
      alert(rtn.resultMsg);
    }

    // 클릭한 팝업에 평가원의 승인된 항목이 있다면 클릭한 취급으로 변경
    if (rtn.data) {
      selectedStandards.value = rtn.data; // API에서 받은 데이터를 선택된 상태로 설정
    }
  }
});


const popupClose = () => {
  store.commit("temp/setIsApprovedStandard");
};
</script>

<style scoped>
/* 전체 트리 스타일 */
.standards-tree {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* 도메인 스타일 */
.domain {
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 10px;
  margin-bottom: 10px;
  background-color: #f9f9f9;
  cursor: pointer;
}
/* 선택된 도메인 스타일 */
.domain.selected {
  background-color: #009FDE; /* 파란색 배경 */
  color: #fff; /* 글자색 */
  font-weight: bold;
}
/* 도메인 타이틀 */
.domain-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* 스탠다드 항목 스타일 */
.standard-item {
  font-size: 14px;
  padding: 5px;
  border-bottom: 1px solid #e0e0e0;
  cursor: pointer;
  transition: background-color 0.2s;
  text-align: left;
}

/* 선택된 스탠다드 항목 */
.standard-item.selected {
  background-color: #009FDE; /* 활성화된 스탠다드 배경색 */
  color: #fff; /* 글자색 변경 */
  font-weight: bold;
}

.popup__btns .btn:disabled {
  background: #ddd;
  color: #aaa;
  cursor: not-allowed;
}
</style>
